import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { eurlTestRegExp } from 'enums/regExp';

export const urlValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || eurlTestRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_URL</TranslateText>);
        }
    })
];

export default urlValidation;
